(function(){
    angular.module('tmx-app').factory("Breadcrumbs",['$state','$translate','routes', 

        function Breadcrumbs($state, $translate,routes) {

            var list = [], title;
            var homeState={
                title:'Inbox',
                state:'private.inbox'
            };
    

            // eslint-disable-next-line no-unused-vars
            function getProperty(object, path) {
                function index(obj, i) {
                    return obj[i];
                }

                return path.split('.').reduce(index, object);
            }

            function addBreadcrumb( state,title) {
                list.push({
                    title: title,
                    state: state
                });
            }

            function generateBreadcrumbs(state) {


                if(angular.isDefined(state.parent)) {
                    generateBreadcrumbs(state.parent);
                }

                if(!angular.isDefined(state.abstract) || !state.abstract) {

                    var route=routes.getRouteByState(state.name);
                    addBreadcrumb( state.name,route.name);
                }
            }

            function appendTitle(translation, index) {
                var title = translation;

                if(index < list.length - 1) {
                    title += ' > ';
                }

                return title;
            }

            function generateTitle() {
                title = '';

                angular.forEach(list, function(breadcrumb, index) {
                    $translate(breadcrumb.title).then(
                        function(translation) {
                            title += appendTitle(translation, index);
                        }, function(translation) {
                            title += appendTitle(translation, index);
                        }
                    );
                });
            }

            return {
                generate: function() {
                    list = [homeState];
                    if(!$state.$current.name !== homeState.state)
             
                        generateBreadcrumbs($state.$current);
                    generateTitle();
                },

                title: function() {
                    return title;
                },

                list: function() {

                    return list;
                },
                generateForState: function(state) {
                    list = [homeState];
                    state=$state.get(state.name);
                    if(!state.name !== homeState.state)
                        generateBreadcrumbs(state);
                    generateTitle();
                }
            };
        }]);

})();
